export var combineFilters = function (filters, preFilter) {
    if (filters === void 0) { filters = []; }
    if (preFilter === void 0) { preFilter = ''; }
    var selectedFilterQuery = filters
        .filter(function (f) { return typeof f.query === 'string' && f.query !== ''; })
        .filter(function (f) { return Boolean(f.selected); })
        .map(function (f) { return "(" + f.query + ")"; })
        .join(' or ');
    if (selectedFilterQuery === '') {
        return preFilter;
    }
    return preFilter ? preFilter + " and (" + selectedFilterQuery + ")" : selectedFilterQuery;
};
